export const IN_APP_NOTIFICATION = 1;
export const BILLING_OVERVIEW = 3;
export const RATE_OVERRIDE_EXPERIMENT = 5;
export const IN_APP_CANCELLATION = 7;
export const IN_APP_CANCELLATION_EA_SAMI = 9;
export const IN_ADVANCE_PAYOUTS = 12;
export const IN_APP_CANCELLATION_2_HOUR_DEADLINE = 15;
export const FACILITY_RATINGS = 16;
export const CLIENT_APP_DASHBOARD = 19;
export const DIRECT_CONNECT_ON_SHIFT_FORCE_ASSIGN = 33;
export const DISPLAY_PURCHASE_ORDER_NUMBER_SETTING = 34;
export const DISABLE_OPTION_TO_ADD_COVID_SHIFTS = 35;
export const REFRESH_USER_AFTER_INACTIVITY = 36;
export const PROFESSIONAL_TWO_WAY_DISPUTE = 38;
export const NEW_ORIENTATION_SHIFT = 39;
export const BLOCK_SHIFTS = 41;
export const CANCELLATION_RECOVERY = 88;
export const BROADCAST_LIMIT_EXTENDED = 91;
export const CANCELLATION_FLOW_V2 = 92;
export const FLEX_SHIFTS_INSTANT_OFFER = 93;
export const FLEX_SHIFTS_ENGAGEMENT_EXPERIMENT_2 = 94;
export const SOM_PROFESSIONALS_AVAILABLE_NOW = 95;
export const DASHBOARD_QUICK_ACTIONS_INLINE = 97;
export const DASHBOARD_QUICK_ACTIONS_HEADER = 98;
export const CANCELLATION_RECOVERY_REDUCE_NOISE = 99;
export const PREMIUM_RATE_NUDGE = 100;
export const LATE_ARRIVAL_NOTIFICATIONS = 101;
export const AUTOMATIC_FAVORITES = 102;
export const BOOSTED_SHIFT_NOTIFICATIONS = 103;
export const ADDITIONAL_REQUESTS = 104;
export const FACILITY_RATINGS_V2 = 105;
export const WORK_SEGMENT_CAPTURE = 106;

export const flags = [
  {
    id: IN_APP_NOTIFICATION,
    name: 'In-App Notification',
  },
  {
    id: BILLING_OVERVIEW,
    name: 'Billing Overview',
  },
  {
    id: RATE_OVERRIDE_EXPERIMENT,
    name: 'Rate Override Experiment',
  },
  {
    id: IN_APP_CANCELLATION,
    name: 'In-App Cancellation',
  },
  {
    id: IN_APP_CANCELLATION_EA_SAMI,
    name: 'In-App Cancellation With EA and SAMI',
  },
  {
    id: IN_ADVANCE_PAYOUTS,
    name: 'Provider In Advance Payments',
  },
  {
    id: IN_APP_CANCELLATION_2_HOUR_DEADLINE,
    name: '2 Hour In-App Cancellation Deadline Test',
  },
  {
    id: FACILITY_RATINGS,
    name: 'Facility Ratings',
  },
  {
    id: CLIENT_APP_DASHBOARD,
    name: 'Client App Dashboard',
  },
  {
    id: DIRECT_CONNECT_ON_SHIFT_FORCE_ASSIGN,
    name: 'Enable Direct Connect for OnShift (force assigning)',
  },
  {
    id: DISPLAY_PURCHASE_ORDER_NUMBER_SETTING,
    name: 'Enable new Purchase Order Number field in facility settings',
  },
  {
    id: DISABLE_OPTION_TO_ADD_COVID_SHIFTS,
    name: 'Disable the option to add COVID related shifts.',
  },
  {
    id: REFRESH_USER_AFTER_INACTIVITY,
    name: 'Refresh user after inactivity',
  },
  {
    id: PROFESSIONAL_TWO_WAY_DISPUTE,
    name: 'Professional Two-way Dispute',
  },
  {
    id: NEW_ORIENTATION_SHIFT,
    name: 'New Orientation Shift',
  },
  {
    id: CANCELLATION_RECOVERY,
    name: 'Cancellation Recovery using DC',
  },
  {
    id: BLOCK_SHIFTS,
    name: 'Block Shifts',
  },
  {
    id: BROADCAST_LIMIT_EXTENDED,
    name: 'Broadcast limit 8 per week',
  },
  {
    id: CANCELLATION_FLOW_V2,
    name: 'Cancellation Flow v2',
  },
  {
    id: FLEX_SHIFTS_INSTANT_OFFER,
    name: 'Flex Shifts Engagement Experiment 1 (card)',
  },
  {
    id: FLEX_SHIFTS_ENGAGEMENT_EXPERIMENT_2,
    name: 'Flex Shifts Engagement Experiment 2 (modal)',
  },
  {
    id: SOM_PROFESSIONALS_AVAILABLE_NOW,
    name: 'SOM Professionals Available Now',
  },
  {
    id: DASHBOARD_QUICK_ACTIONS_INLINE,
    name: 'Dashboard Quick Actions Center – Inline',
  },
  {
    id: DASHBOARD_QUICK_ACTIONS_HEADER,
    name: 'Dashboard Quick Actions Center – Header',
  },
  {
    id: CANCELLATION_RECOVERY_REDUCE_NOISE,
    name: 'Cancellation Recovery – skip notification if last invite is still unseen (< 24h)',
  },
  {
    id: PREMIUM_RATE_NUDGE,
    name: 'Premium Rate Nudge',
  },
  {
    id: LATE_ARRIVAL_NOTIFICATIONS,
    name: 'Late Arrival Notifications',
  },
  {
    id: AUTOMATIC_FAVORITES,
    name: 'Automatic Favorites',
  },
  {
    id: BOOSTED_SHIFT_NOTIFICATIONS,
    name: 'Boosted Shift Notifications',
  },
  {
    id: WORK_SEGMENT_CAPTURE,
    name: 'Work Segment Capture',
  },
  {
    id: ADDITIONAL_REQUESTS,
    name: 'Additional Requests',
  },
  {
    id: FACILITY_RATINGS_V2,
    name: 'Facility Ratings V2',
  },
];
